<template>
  <div class="form-group row">
    <label class="col-md-4 col-form-label text-md-right">Φόρτωση Αρχείου</label>
    <div class="col-md-2">
      <input type="file" id="fileUpload" ref="file" v-on:change="handleFileUpload" />
    </div>
  </div>
</template>

<script>
export default {
    name: 'UploadFile',
    data: function(){
        return {
            filebase64: ''
        }
    },
    methods: {
        handleFileUpload(){
            
            if (!this.$validator.isAllowedFormat(this.$refs.file.files[0].name)) {
                document.getElementById("fileUpload").value = "";
                this.flag_file = true;
                return;
            }
            let that = this;
            let reader = new FileReader();
            reader.onload = function() {
                let dataURL = reader.result;
                that.$emit('fileUploaded', dataURL.replace(/^[^,]*,/,''));
            };
            reader.readAsDataURL(this.$refs.file.files[0]);
        },
    }
};
</script>
